import React from 'react'
import { VscDebugBreakpointDataUnverified } from "react-icons/vsc";


const ServiceComponent = () => {
  return (
    <div>
         <div className="mt-8 mx-8">
              <h2 className="font-semibold text-4xl">Our Services</h2>
          </div>
            <div className="grid md:grid-cols-2 gap-10 mt-10 m-10 ">
        <div className="flex gap-4 items-start">
            <span className="text-yellow-600 bg-yellow-500/10 p-3 rounded-full">
                <VscDebugBreakpointDataUnverified size={26} />
            </span>
            <div>
                <h3 className="font-semibold text-xl text-justify">Comprehensive Coverage</h3>
                <p className="mt-1 text-gray-500 text-justify"> At OZ Wide, we offer a variety of coverage options to ensure your business is protected on the road: Liability coverage, Collision Coverage, Comprehensive Coverage, Uninsured/Underinsured Motorist Coverage.</p>
            </div>
        </div>


        <div className="flex gap-4 items-start">
        <span className="text-yellow-600 bg-yellow-500/10 p-3 rounded-full">
                <VscDebugBreakpointDataUnverified size={26} />
            </span>
            <div>
                <h3 className="font-semibold text-xl text-justify">Expert Guidance from Licensed Professionals</h3>
                <p className="mt-1 text-gray-500 text-justify"> Our team consists of licensed experts who understand the complexities of insurance. They are dedicated to helping you navigate through different policies and coverage options. With their extensive knowledge and experience, they can explain intricate terms in simple language, ensuring you make informed decisions about your coverage.</p>
            </div>
        </div>


        <div className="flex gap-4 items-start">
        <span className="text-yellow-600 bg-yellow-500/10 p-3 rounded-full">
                <VscDebugBreakpointDataUnverified size={26} />
            </span>
            <div>
                <h3 className="font-semibold text-xl text-justify">Personalized Service and Support</h3>
                <p className="mt-1 text-gray-500 text-justify"> We pride ourselves on offering personalized service tailored to each client’s unique situation. Our agents take the time to understand your individual needs and preferences. Whether you’re a first-time buyer or looking to adjust existing coverage, we provide customized support every step of the way.</p>
            </div>
        </div>


        <div className="flex gap-4 items-start">
        <span className="text-yellow-600 bg-yellow-500/10 p-3 rounded-full">
                <VscDebugBreakpointDataUnverified size={26} />
            </span>
            <div>
                <h3 className="font-semibold text-xl text-justify">Advocacy During Claims Process</h3>
                <p className="mt-1 text-gray-500 text-justify"> In times of need, we act as your advocate. If you face any issues regarding claims or billing, our agents will work on your behalf with the insurance company to resolve these matters efficiently. This advocacy ensures that you receive fair treatment and prompt assistance when it matters most. </p>
            </div>
        </div>


        <div className="flex gap-4 items-start">
        <span className="text-yellow-600 bg-yellow-500/10 p-3 rounded-full">
                <VscDebugBreakpointDataUnverified size={26} />
            </span>
            <div>
                <h3 className="font-semibold text-xl text-justify">Ongoing Policy Reviews</h3>
                <p className="mt-1 text-gray-500 text-justify"> We believe in proactive management of your insurance needs. Our agents regularly review your coverage to ensure it remains aligned with any changes in your life circumstances—such as moving homes, starting a family, or launching a business—so that you’re always adequately protected. </p>
            </div>
        </div>


        <div className="flex gap-4 items-start">
        <span className="text-yellow-600 bg-yellow-500/10 p-3 rounded-full">
                <VscDebugBreakpointDataUnverified size={26} />
            </span>
            <div>
                <h3 className="font-semibold text-xl text-justify">Competitive Pricing</h3>
                <p className="mt-1 text-gray-500 text-justify">Our commitment is not just about providing excellent service but also about offering competitive pricing. We strive to find the best value for your money by comparing quotes from various insurers while considering both price and coverage quality.</p>
            </div>
        </div>

    </div>
    
    </div>
  )
}

export default ServiceComponent
